import type { NewsItem } from "@/lib/types";

export function slugify(s: string): string {
  const out = s
    .toLowerCase()
    .normalize("NFKD")
    .replace(/\p{M}/gu, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
  return out || "dispaccio";
}

export function articleHref(item: Pick<NewsItem, "id" | "title">): string {
  return `/article/${item.id}/${slugify(item.title)}`;
}
